import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-invoice-tracker-preview',
  templateUrl: './invoice-tracker-preview.component.html',
  styleUrls: ['./invoice-tracker-preview.component.css']
})
export class InvoiceTrackerPreviewComponent {

  showFixedRateTable: boolean = false;
  showDefaultTable: boolean = false;
  invtot: any = 0;
  tooltaxPaidtot: any = 0;
  extrahour: any = 0;
  kmtot: any = 0;
  billno: string;
  users: any[] = [];
  paramId: string;

  constructor(
    public dialogRef: MatDialogRef<InvoiceTrackerPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.getTrackerInvoice(this.data);
  }


  // 🔹 TRACKER INVOICE FETCH (same structure as LR)
  getTrackerInvoice(id: string) {

    const rawdata = this.data;
    this.billno = rawdata[0]?.billno || '';
    const invoiceType = rawdata[0]?.invoiceType || rawdata[0]?.invoice[0]?.invoiceTypeName?.[0] || 'Type1';
    const type = invoiceType?.trim();
    const isFixedRate = type === 'Fixed Rate Invoice' || type === 'Monthly Fixed Invoice';

    if (isFixedRate) {
      this.showFixedRateTable = true;
      this.showDefaultTable = false;
    } else {
      this.showFixedRateTable = false;
      this.showDefaultTable = true;
    }

    this.users = rawdata[0]?.invoice || [];

    // RESET TOTALS
    this.invtot = 0;
    this.kmtot = 0;
    this.extrahour = 0;
    this.tooltaxPaidtot = 0;

    // CALCULATE TOTALS (SAME AS LR)
    this.users.forEach((user: any) => {
      this.invtot += (user.vehicleRate || []).reduce(
        (a: number, b: any) => a + Number(b || 0),
        0
      );
      this.kmtot += (user.up_down_km || []).reduce(
        (a: number, b: any) => a + Number(b || 0),
        0
      );
      this.extrahour += (user.extrahour || []).reduce(
        (a: number, b: any) => a + Number(b || 0),
        0
      );
      this.tooltaxPaidtot += (user.tooltaxPaid || []).reduce(
        (a: number, b: any) => a + Number(b || 0),
        0
      );
    });
  }

  declineInvoice() {
    this.dialogRef.close({
      status: "decline",
    })
  }

  approveInvoice() {
    this.dialogRef.close({
      status: "approved",
      billno: this.billno
    })
  }
  sendInvoice(divName) { }
  backTo() { }

  getDisplayValue(value: any): string {
    if (value === null || value === undefined || value === '') return '-';
    return value;
  }

  getTopDisplayValue(value: any): string {
    if (value === null || value === undefined || value === '') return 'N/A';
    return value;
  }

  getActualWorkingDays(startDate: any, endDate: any): any {
    if (!startDate || !endDate) return '-';
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return '-';
    const diffTime = Math.abs(end.getTime() - start.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays === 0 ? 1 : diffDays;
  }

  getNum(value: any): number {
    if (value === null || value === undefined || value === '') return 0;
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }

  getExtraKmVal(user: any, i: number): number {
    const totalKm = this.getNum(user.up_down_km?.[i]);
    const fixedKm = this.getNum(user.fixedKM?.[i]);
    return Math.max(0, totalKm - fixedKm);
  }

  getAmountForKm(user: any, i: number): number {
    return this.getExtraKmVal(user, i) * this.getNum(user.extraKMCost?.[i]);
  }

  getAmountForExtraHrs(user: any, i: number): number {
    return this.getNum(user.extrahour?.[i]) * this.getNum(user.variableCostHr?.[i]);
  }

  getRowTotalAmount(user: any, i: number): number {
    const A = this.getNum(user.fixedPaymentMonth?.[i]);
    const B = this.getAmountForKm(user, i);
    const C = this.getAmountForExtraHrs(user, i);
    const D = this.getNum(user.tooltaxPaid?.[i]);
    const E = this.getNum(user.otherPayment?.[i]);
    return A + B + C + D + E;
  }

  getGrandTotal(users: any[]): number {
    let total = 0;
    if (!users || !users.length) return 0;
    for (let user of users) {
      if (user.vehicle_id) {
        for (let i = 0; i < user.vehicle_id.length; i++) {
          total += this.getRowTotalAmount(user, i);
        }
      }
    }
    return total;
  }
}


